import { client, unwrap } from './adminOperationsService';

export const resourcePath = (key, id) => {
  if (!/^[a-z0-9_]+\/[a-z0-9_]+$/.test(key)) throw new Error('Invalid admin resource.');
  return `/${key}/${id === undefined ? '' : `${encodeURIComponent(id)}/`}`;
};

export const actionPath = (key, url) => {
  const pathname = new URL(url, window.location.origin).pathname;
  const prefix = `/apiadmin${resourcePath(key)}`;
  if (!pathname.startsWith(prefix) || !/^[a-z0-9_-]+\/$/i.test(pathname.slice(prefix.length))) {
    throw new Error('Invalid admin action URL.');
  }
  return pathname.slice('/apiadmin'.length);
};

const adminConsole = {
  catalog: () => unwrap(client.get('/console/catalog/')),
  schema: (key) => unwrap(client.options(resourcePath(key))),
  list: (key, params) => unwrap(client.get(resourcePath(key), { params })),
  detail: (key, id) => unwrap(client.get(resourcePath(key, id))),
  create: (key, data) => unwrap(client.post(resourcePath(key), data)),
  update: (key, id, data) => unwrap(client.patch(resourcePath(key, id), data)),
  remove: (key, id) => unwrap(client.delete(resourcePath(key, id))),
  action: (key, action, data) => unwrap(client.post(actionPath(key, action.url), data)),
  keepers: () => unwrap(client.get('/console/keepers/')),
  read: (path, params) => unwrap(client.get(path, { params })),
  operate: (path, data) => unwrap(client.post(path, data)),
};
export default adminConsole;
